import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const actions = createActions(
  {
    PERSONAL_SUBMIT_MESSAGE_WITH_ENTER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_BUSYLIGHT: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_KEYBOARD_SHORTCUTS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_LEFT_MENU: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_SOUND: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_LAST_FROM_EMAIL_INTEGRATION: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_REPLY_AREA_HEIGHT: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_TOGGLE_REMEMBER_MICROPHONE_ACCESS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_CHANGED_ELEVIO_SELECTED_LANGUAGE: [
      (payload: { selectedLanguageId: string }) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'PERSONAL_SUBMIT_MESSAGE_WITH_ENTER_SUCCEEDED',
  'PERSONAL_SUBMIT_MESSAGE_WITH_ENTER_FAILED',

  'PERSONAL_LEFT_MENU_SUCCEEDED',
  'PERSONAL_LEFT_MENU_FAILED',

  'PERSONAL_LEFT_MENU_SUCCEEDED',
  'PERSONAL_LEFT_MENU_FAILED',

  'PERSONAL_BUSYLIGHT_SUCCEEDED',
  'PERSONAL_BUSYLIGHT_FAILED',

  'PERSONAL_KEYBOARD_SHORTCUTS_SUCCEEDED',
  'PERSONAL_KEYBOARD_SHORTCUTS_FAILED',

  'PERSONAL_SOUND_SUCCEEDED',
  'PERSONAL_SOUND_FAILED',

  'PERSONAL_LAST_FROM_EMAIL_INTEGRATION_SUCCEEDED',
  'PERSONAL_LAST_FROM_EMAIL_INTEGRATION_FAILED',

  'PERSONAL_REPLY_AREA_HEIGHT_SUCCEEDED',
  'PERSONAL_REPLY_AREA_HEIGHT_FAILED',

  'PERSONAL_ADD_TO_FAVOURITE_QUEUE_IDS_SUCCEEDED',
  'PERSONAL_ADD_TO_FAVOURITE_QUEUE_IDS_FAILED',

  'PERSONAL_REMOVE_FROM_FAVOURITE_QUEUE_IDS_SUCCEEDED',
  'PERSONAL_REMOVE_FROM_FAVOURITE_QUEUE_IDS_FAILED',

  'PERSONAL_TOGGLE_REMEMBER_MICROPHONE_ACCESS_SUCCEEDED',
  'PERSONAL_TOGGLE_REMEMBER_MICROPHONE_ACCESS_FAILED',

  'PERSONAL_CHANGED_ELEVIO_SELECTED_LANGUAGE_SUCCEEDED',
  'PERSONAL_CHANGED_ELEVIO_SELECTED_LANGUAGE_FAILED',
);
